import React from "react";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { CarrierTabEmptyRow, CarrierTabLoadingRow } from "./carrierTabTablePrimitives";

function carrierInfoRowKey(row) {
  if (row.license_id != null && row.license_id !== "") return String(row.license_id);
  const t = row.license_info_type ?? "";
  const v = row.license_info_value ?? "";
  return `carrier-info-${t}-${v}`;
}

export default function CarrierCarrierInfoTabPanel({ vm }) {
  const {
    handleDeleteLicenseInfo,
    setOpenAddLicenseDialog,
    handleOpenEditLicense,
    licenseLoading,
    licenseInfos,
    headerRowSx,
    tableCardSx,
  } = vm;

  const renderBody = () => {
    if (licenseLoading) {
      return <CarrierTabLoadingRow colSpan={3} />;
    }
    if (licenseInfos.length === 0) {
      return <CarrierTabEmptyRow colSpan={3} message="No carrier info found." />;
    }
    return licenseInfos.map((row) => (
      <TableRow key={carrierInfoRowKey(row)}>
        <TableCell>{row.license_info_type || ""}</TableCell>
        <TableCell>{row.license_info_value || ""}</TableCell>
        <TableCell align="right">
          <IconButton color="primary" onClick={() => handleOpenEditLicense(row)}>
            <EditIcon />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteLicenseInfo(row.license_id)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      </TableRow>
    ));
  };

  return (
    <>
      <Box sx={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenAddLicenseDialog(true)}
        >
          Add Carrier Info
        </Button>
      </Box>
      <TableContainer component={Paper} sx={tableCardSx}>
        <Table>
          <TableHead>
            <TableRow sx={headerRowSx}>
              <TableCell>Type</TableCell>
              <TableCell>Value</TableCell>
              <TableCell align="right">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{renderBody()}</TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

CarrierCarrierInfoTabPanel.propTypes = {
  vm: PropTypes.object.isRequired,
};
